import { SidebarItem } from '@/pages/company-drawer/company-overview/set-irq-modal/irq-sidebar/sidebar-item'
import { type SidebarStep } from '@/pages/company-drawer/company-overview/set-irq-modal/types'
import { buildSidebarRenderItems } from '@/pages/company-drawer/company-overview/set-irq-modal/utils'

type IrqSidebarProps = {
  steps: SidebarStep[]
  currentIndex: number
  onStepClick: (index: number) => void
  validatedSet: Set<string>
}

const itemKey = (item: ReturnType<typeof buildSidebarRenderItems>[number], i: number) => {
  if (item.kind === 'separator') return `sep-${i}`
  if (item.kind === 'category-header') return `cat-${item.category}-${i}`
  return `step-${item.index}`
}

export const IrqSidebar = ({ steps, currentIndex, onStepClick, validatedSet }: IrqSidebarProps) => {
  const items = buildSidebarRenderItems(steps)

  return (
    <nav className='flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto'>
      {items.map((item, i) => (
        <SidebarItem
          key={itemKey(item, i)}
          item={item}
          currentIndex={currentIndex}
          validatedSet={validatedSet}
          onStepClick={onStepClick}
        />
      ))}
    </nav>
  )
}
